const commercialBonus = {
  bonusType: {
    label: "Type",
    options: {
      quotePunctual: "Ponctuel sur devis",
      orderPunctual: "Ponctuel sur commande",
    }
  },
  base: {
    label: "Base"
  },
  percentage: {
    label: "Pourcentage final"
  },
  amount: {
    label: "Valeur"
  },
  user: {
    label: "Commercial"
  },
  createdAtTimeframe: {
    label: "Création"
  },
  receivedAtPrevisionTimeframe: {
    label: "Date de réception prévisionelle"
  },
  receivedAtTimeframe: {
    label: "Date de réception"
  },
  origin: {
    label: {
      quote: "Devis",
      order: "Commande"
    }
  },
  details: {
    label: "Details",
    header: {
      origin:"Origine",
      sellingPrice: "Prix de vente",
      calculationBase: "Base calcul",
      percentage: "Pourcentage",
      bonusAmount: "Commission",
      validated: "Validé",
    }
  },
  comment: {
    label: "Commentaire"
  },
  receivedAtPrevision: {
    label: "Prévision de réception"
  },
  receivedAt: {
    label: "Réception"
  },
  validated: {
    label: "Commission validée?"
  }
};

export default commercialBonus;
